'use client';

import type { ActivityDTO } from 'src/types/dto';

import { makeAutoObservable } from 'mobx';

class ActionPanelStore {
  isAllocating: boolean = false;

  allocationProgress: number = 0;

  planboxId: number | null = null;

  selectedActivities: ActivityDTO[] = [];

  showOnlySelectedActivities: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setAllocating(isAllocating: boolean) {
    this.isAllocating = isAllocating;
  }

  setAllocationProgress(progress: number) {
    this.allocationProgress = progress;
  }

  setPlanboxId(id: number | null) {
    this.planboxId = id;
  }

  setSelectedActivities(activities: ActivityDTO[]) {
    this.selectedActivities = activities;
  }

  setShowOnlySelectedActivities(show: boolean) {
    this.showOnlySelectedActivities = show;
  }

  reset() {
    this.isAllocating = false;
    this.allocationProgress = 0;
    this.planboxId = null;
    this.selectedActivities = [];
    this.showOnlySelectedActivities = false;
  }
}

export const actionPanelStore = new ActionPanelStore(); 